import { SiteControlWidget } from '@scaleaq/sitecontrol-lib';

import { getWidgetConstraints } from '@/pages/landingPage/grid/widgetConstraints.ts';

type getConstrainedWidgetProps = {
  enablePreviewContent?: boolean;
  widget: SiteControlWidget;
};

export const getConstrainedWidget = ({ widget }: getConstrainedWidgetProps) => {
  const { componentName, w, h } = widget;
  const widgetConstraints = getWidgetConstraints(componentName);
  // Constrain on max values
  const constrainedMaxW = Math.min(w, widgetConstraints.maxW ?? w);
  const constrainedMaxH = Math.min(h, widgetConstraints.maxH ?? h);

  // constrain on min values
  const constrainedW = Math.max(constrainedMaxW, widgetConstraints.minW ?? constrainedMaxW);
  const constrainedH = Math.max(constrainedMaxH, widgetConstraints.minH ?? constrainedMaxH);

  return {
    ...widget,
    ...widgetConstraints,
    w: constrainedW,
    h: constrainedH,
    isChanged: constrainedW !== w || constrainedH !== h,
  };
};
